import { CheckIcon, ZoomInIcon } from '@heroicons/react/outline'
import { ModalStore } from '../state/ModalStore'
import ImageModal from './Modals/ImageModal'
import { useEffect, useState } from 'react'
import Loader from './Loader'
import Image from 'next/image'
import { Listbox } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
// import { useRouter } from 'next/router'

const SelectionComponent = ({ isSelected, image }) => {
    return isSelected?.url == image.url ? (
        <div className={'absolute inset-0 flex items-center justify-center'}>
            <div className="bg-white opacity-80 w-full h-full absolute"></div>
            <CheckIcon className="w-16 h-16 text-olm-green z-10" />
        </div>
    ) : null
}

function TemplatesComponent({
    onSelect,
    selected,
    templates_and_attributes,
    templateIndustries,
}) {
    const allIndustriesOption = 'All Industries'

    const [loading] = useState(false)
    const addModal = ModalStore((state) => state.add)

    const [industries, setIndustries] = useState([])

    // const router = useRouter()

    const [isSelected, setIsSelected] = useState({})
    const [selectedIndustry, setSelectedIndustry] =
        useState(allIndustriesOption)

    const [templates, setTemplates] = useState(templates_and_attributes)

    const sizeClasses = 'grid-cols-2 gap-3 md:grid-cols-5 md:gap-5'

    const handlefullSizeImage = (image) => {
        addModal(<ImageModal name={image.name} url={image.url} />)
    }

    const handleSelect = (selectedTemplate) => {
        setIsSelected((state) => {
            const updatedState =
                state?.url == selectedTemplate.url ? null : selectedTemplate
            onSelect(selectedTemplate)
            return updatedState
        })
    }

    // https://admin.openlettermarketing.com/wp-content/u…/Product-Image-Letter-with-envelope-mockup-13.jpg

    useEffect(() => {
        if (selected) {
            setIsSelected(selected)
        }
    }, [selected])

    // useEffect(() => {
    //     if (router.query?.template && router.query?.templateName) {
    //         const template = {
    //             url: router.query?.template,
    //             name: router.query?.templateName,
    //         }
    //         handleSelect(template)
    //     }
    // }, [router.query])

    // useEffect(() => {
    //     // log('attributes', attributes)
    // }, [attributes])

    useEffect(() => {
        let filteredTemplates
        if (selectedIndustry != allIndustriesOption) {
            filteredTemplates = templates_and_attributes.filter(
                ({ template }) => template.industry == selectedIndustry,
            )
        } else {
            filteredTemplates = [...templates_and_attributes]
        }
        setTemplates(filteredTemplates)
    }, [selectedIndustry])

    useEffect(() => {
        const industriesWithTemplates = templates_and_attributes.map(
            ({ template }) => template.industry,
        )
        setIndustries([
            allIndustriesOption,
            ...new Set(industriesWithTemplates),
        ])
    }, [templateIndustries])

    return (
        <div className="w-full">
            {loading && <Loader text="Loading Templates..." />}

            <div className="flex justify-start items-center space-x-2 mb-4">
                <div className="text-sm font-medium">Sort by</div>
                <div className="w-60 my-2">
                    <Listbox
                        value={selectedIndustry}
                        onChange={setSelectedIndustry}>
                        <div className="relative">
                            <Listbox.Button className="relative w-full border py-2 pl-3 pr-10 text-left bg-white rounded-lg shadow-md cursor-pointer sm:text-sm">
                                {selectedIndustry}
                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                    <ChevronDownIcon className="w-5 h-5 text-gray-400" />
                                </span>
                            </Listbox.Button>

                            <Listbox.Options className="absolute z-20 w-60 py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                {industries.map((industry, i) => (
                                    <Listbox.Option
                                        key={i}
                                        className={({ active }) =>
                                            `${
                                                active
                                                    ? 'text-white bg-olh'
                                                    : 'text-olm'
                                            }
              cursor-default select-none relative py-2 pl-10 pr-4 text-left`
                                        }
                                        value={industry}>
                                        {({ selected, active }) => (
                                            <>
                                                <span
                                                    className={`${
                                                        selected
                                                            ? 'font-medium'
                                                            : 'font-normal'
                                                    } block truncate`}>
                                                    {industry}
                                                </span>
                                                {selected ? (
                                                    <span
                                                        className={`${
                                                            active
                                                                ? 'text-white'
                                                                : 'text-olh'
                                                        } absolute inset-y-0 left-0 flex items-center pl-4`}>
                                                        <CheckIcon
                                                            className="w-5 h-5"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </div>
                    </Listbox>
                </div>
            </div>
            <div className="h-[500px] overflow-y-scroll">
                {templates && templates.length > 0 ? (
                    <div className={`grid ${sizeClasses}`}>
                        {templates.map(({ template: image }, idx) => (
                            <div
                                key={idx}
                                data-template-id={image?.name}
                                className="relative h-64 md:h-64 overflow-hidden bg-slate-50 border border-slate-200 rounded-md
                                    items-center flex flex-col">
                                <div className="flex-grow flex flex-col w-full">
                                    <div
                                        className="relative cursor-pointer flex-grow"
                                        onClick={() => handleSelect(image)}>
                                        <div className="w-full h-52 overflow-hidden">
                                            {image?.url && (
                                                <Image
                                                    src={image.url}
                                                    height={208}
                                                    width={180}
                                                    className="w-full h-full object-cover"
                                                />
                                            )}
                                        </div>

                                        <SelectionComponent
                                            {...{
                                                isSelected,
                                                image,
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col justify-center h-full">
                                    <div className="text-olm-black text-sm font-medium w-full">
                                        <p className="text-center">
                                            {image?.name}
                                        </p>
                                    </div>
                                </div>

                                <button
                                    className="absolute right-0 m-2 bottom-0 bg-white p-1  opacity-80 hover:opacity-100"
                                    onClick={() => handlefullSizeImage(image)}>
                                    <ZoomInIcon className="w-6 h-6" />
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center m-auto justify-center items-center flex max-w-lg h-64 ">
                        <div className="text-center space-y-5">
                            <p className="flex space-x-1 text-olm-black font-medium text-sm">
                                <span>Loading Templates...</span>
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default TemplatesComponent
